module.exports = __webpack_public_path__ + "img/icon-reference.fdc65ff3.svg";